'use client'

import { twMerge } from '@/lib/classname/twMerge'
import type { PropsWithChildren, RefAttributes } from 'react'
import type { DisclosureProps } from 'react-aria-components'
import { Disclosure } from 'react-aria-components'
import { AccordionItemHeader } from './_components/AccordionItemHeader'
import { AccordionItemPanel } from './_components/AccordionItemPanel'
import { AccordionContext } from './_context/AccordionContext'

export type AccordionItemProps = UiComponentProps &
  PropsWithChildren &
  DisclosureProps &
  RefAttributes<HTMLDivElement>

function AccordionItem({ id, children, className, ...props }: AccordionItemProps) {
  return (
    <Disclosure
      id={id}
      data-testid={`accordion-item-${id}`}
      className={twMerge('border-b-1.5 border-brand-2-200 last:border-b-0', className)}
      {...props}
    >
      <AccordionContext.Provider value={id}>{children}</AccordionContext.Provider>
    </Disclosure>
  )
}

AccordionItem.Header = AccordionItemHeader
AccordionItem.Panel = AccordionItemPanel

export { AccordionItem }
